<template>
  <aside class="dashboard-nav" :class="{ 'is-collapsed': collapsed && canCollapse }">
    <div class="dashboard-nav-items">
      <template v-for="item in visibleItems" :key="item.key">
        <button
          v-if="item.type !== 'link'"
          type="button"
          class="dashboard-nav-action dashboard-nav-expandable"
          :class="{ 'is-active': activePanel === item.key }"
          @click="$emit('toggle-panel', item.key)"
        >
          <span class="dashboard-nav-icon">
            <component :is="item.icon" v-if="item.icon" />
            <span v-else>•</span>
          </span>
          <span class="dashboard-nav-title">{{ item.label }}</span>
          <NavMetaStateIcon :state="activePanel === item.key ? 'expanded' : 'collapsed'" />
        </button>
        <a v-else :href="item.url" class="dashboard-nav-action dashboard-nav-link">
          <span class="dashboard-nav-icon">
            <component :is="item.icon" v-if="item.icon" />
            <span v-else>↗</span>
          </span>
          <span class="dashboard-nav-title">{{ item.label }}</span>
          <NavMetaStateIcon state="open" />
        </a>
      </template>
    </div>

    <div class="dashboard-nav-bottom-controls">
      <DashboardNavCornerControls
        :can-toggle-full-width="canToggleFullWidth"
        :is-full-width="isFullWidth"
        :can-collapse="canCollapse"
        :collapsed="collapsed"
        @toggle-full-width="$emit('toggle-full-width')"
        @toggle-collapse="$emit('toggle-collapse')"
      />
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue'
import DashboardNavCornerControls from './DashboardNavCornerControls.vue'
import NavMetaStateIcon from './NavMetaStateIcon.vue'

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activePanel: {
    type: String,
    default: null,
  },
  collapsed: {
    type: Boolean,
    default: false,
  },
  canCollapse: {
    type: Boolean,
    default: true,
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
  canToggleFullWidth: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['toggle-panel', 'toggle-collapse', 'toggle-full-width'])

const visibleItems = computed(() => props.items.filter(item => item && item.label))
</script>

<style scoped>
.dashboard-nav {
  position: sticky;
  top: var(--dashboard-sticky-top, 12px);
  max-height: none;
  overflow: visible;
  padding-bottom: 0;
}

.dashboard-nav-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dashboard-nav-icon {
  font-size: 13px;
  line-height: 1;
}

.dashboard-nav-title {
  white-space: normal;
  line-height: 1.2;
  max-width: none;
}

.dashboard-nav.is-collapsed .dashboard-nav-title,
.dashboard-nav.is-collapsed .dashboard-nav-meta {
  display: none;
}
</style>
